<template>
  <div role="tabpanel" :class="['tab-pane', {'active': active}, stepClass]">
      <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    step: {
      type: String
    },
    description: {
      type: String
    },
    icon: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    },
    target: {
      type: Object,
      default() {
        return this.$parent;
      }
    },
    name: {
      type: String
    },
    stepClass: {}
  },
  created() {
    this.target.addStep(this);
  }
}
</script>
